import * as React from 'react';
import { styled, memoizeFunction } from '../../Utilities';
import { CheckBase } from './Check.base';
import { getStyles } from './Check.styles';
export var Check = styled(CheckBase, getStyles, undefined, {
    scope: 'Check'
}, true);
/**
 * Memoized helper for rendering a Check. Always uses fast icons.
 * @param theme - Theme, so the check can be re-rendered if it changes.
 * @param checked - Whether the check is checked.
 * @param className - Class name for styling the check.
 */
export var getCheck = memoizeFunction(function (theme, checked, className) {
    return React.createElement(Check, { theme: theme, checked: checked, className: className, useFastIcons: true });
});
//# sourceMappingURL=Check.js.map